import languagesJson from "@myvp/shared/src/i18n/languages.json"

const textDirectionMap: ReadonlyMap<string, "rtl" | "ltr"> = new Map(
  languagesJson.languages.map((locale) => [
    locale.tag,
    locale.charDirection === "RTL" ? "rtl" : "ltr",
  ])
)

export const getTextDirection = (locale: string) => {
  return textDirectionMap.get(locale) ?? "ltr"
}
